<template>
  <div class="api-in-dash">
    <div class="api-in-dash-title">调用平台占比</div>
    <div class="result" id="userFromChart"></div>
  </div>
</template>

<script>
import * as echarts from "echarts/core";
import { TooltipComponent, LegendComponent } from "echarts/components";
import { PieChart } from "echarts/charts";
import { LabelLayout } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
echarts.use([
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
  LabelLayout,
]);
import { getDashPart } from "@/api/user";

export default {
  name: "ApiInDash",
  props: {},
  data() {
    return {
      mychar: null,
      option: {
        tooltip: {
          trigger: "item",
          formatter: "{a}<br/> {b} : {c} ({d}%)",
        },
        legend: {
          bottom: "0",
          left: "center",
        },
        series: [
          {
            name: "调用方式",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
            },
            data: [
              { value: 100, name: "微信公众号" },
              { value: 160, name: "微信小程序" },
              { value: 321, name: "在线网页版" },
              { value: 421, name: "API调用" },
              { value: 400, name: "未标记" },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    this.initChart();
  },
  watch: {
    "$store.getters.getMenuOpen": function () {
      this.onResize();
    },
  },
  methods: {
    initChart() {
      const chartDom = document.getElementById("userFromChart");
      chartDom.addEventListener("onresize", this.onResize);
      getDashPart().then((res) => {
        this.option.series[0].data = [
          {
            value: res.data.wechat,
            name: "微信公众号",
          },
          {
            value: res.data.miniapp,
            name: "微信小程序",
          },
          {
            value: res.data.web,
            name: "在线网页版",
          },
          {
            value: res.data.api,
            name: "API调用",
          },
          {
            value: res.data.other,
            name: "未标记",
          },
        ];
        this.mychar.setOption(this.option);
      });
      this.mychar = echarts.init(chartDom);
    },
    onResize() {
      this.mychar.resize();
    },
  },
};
</script>

<style lang="less" scoped>
.api-in-dash {
  margin-left: 2rem;
  flex: 1;
  overflow: hidden;
  height: 400px;
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  .api-in-dash-title {
    font-size: 1.4rem;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 1rem;
    opacity: 0.9;
    text-align: center;
  }
  .result {
    width: 100%;
    height: 400px;
    width: 300px;
  }
}
</style>
